import React from "react";
import { Button } from "../../Common/Buttons/Button";
import DropdownMenu, { ActionsProps } from "../../Inputs/DropdownMenu";

const CarouselModalActionButton = ({
  actions,
}: {
  actions: ActionsProps[];
}) => {
  if (actions.length === 0) {
    return null;
  }

  const button = ({
    onClick,
  }: {
    onClick: (_: React.MouseEvent<HTMLElement>) => void;
  }) => {
    return (
      <Button
        variant="outlineInverted"
        title="Actions"
        onClick={onClick}
        size="small"
        iconEnd="chevron-down"
      />
    );
  };

  return (
    <DropdownMenu
      buttonText={"Actions"}
      actions={actions}
      customButton={button}
    />
  );
};

export default CarouselModalActionButton;
